<template>
  <label class="checkbox" :class="classList" role="checkbox">
    <input
      type="checkbox"
      :disabled="disabled"
      :value="value"
      @input="input"
      @focus="isFocused = true"
      @blur="isFocused = false"
      class="checkbox__control"
    >
    <div class="checkbox__icon"></div>
    <div class="checkbox__label">
      <slot>
        <span v-html="label"></span>
      </slot>
    </div>
    <div class="checkbox__error subtext" v-if="error" v-html="error"></div>
  </label>
</template>

<script>
  export default {
    props: {
      error: { type: String },
      label: { type: String },
      disabled: { type: Boolean, default: false },
      value: { type: Boolean, default: false }
    },
    data () {
      return {
        isFocused: false
      }
    },
    computed: {
      classList () {
        return {
          'checkbox--focused': this.isFocused,
          'checkbox--disabled': this.disabled,
          'checkbox--checked': this.value,
        }
      }
    },
    methods: {
      input () {
        this.$emit('input', !this.value)
      }
    }
  }
</script>

<style lang="scss">
  .checkbox {
    display: inline-block;
    cursor: pointer;
    position: relative;
    padding-left: 20px;
    &:hover, &.checkbox--focused {
      color: $color-cyan
    }
  }

  .checkbox__control {
    position: absolute;
    width: 1px;
    height: 1px;
    outline: none;
    left: -9999px;
  }

  .checkbox__icon {
    position: absolute;
    left: 0;
    top: 3px;
    width: 1em;
    height: 1em;
    font-size: 10px;
    border: 1px solid;
    background: #fff;
    margin-right: 10px;

    &:before {
      content: '';
      display: block;
      width: 1em;
      height: 1em;
      font-size: 5px;
      position: absolute;
      top: 50%;
      left: 50%;
      background: #000;
      transform: translate(-50%, -50%);
      opacity: 0;
    }
  }

  .checkbox--checked .checkbox__icon:before {
    opacity: 1;
  }

  .checkbox__label {
    display: inline;
    font-size: 12px;
    line-height: 18px;
  }

  .checkbox--disabled {
    pointer-events: none;
    opacity: 0.7;
  }

  .checkbox__error {
    margin-top: 4px;
    color: $color-red
  }
</style>
